import {AfterViewInit, Component, ElementRef, Input, ViewChild} from '@angular/core';

@Component({
    templateUrl: './image-zoom.component.html',
    styleUrls: ['./image-zoom.component.scss'],
    standalone: false
})
export class ImageZoomComponent implements AfterViewInit {

  @ViewChild('imageZoom') imageZoomRef: ElementRef;

  @Input() host: HTMLElement;
  @Input() content: string;
  @Input() delay: number;

  public imageZoomStyle: any;

  constructor() {
    this.imageZoomStyle = {};
  }

  ngAfterViewInit() {
    const hostBoundingBox: ClientRect = this.host.getBoundingClientRect();
    const imageZoomBoundingBox: ClientRect = this.imageZoomRef.nativeElement.getBoundingClientRect();
    let top: number;
    let left: number;
    if (hostBoundingBox.top + imageZoomBoundingBox.height / 2 >  window.innerHeight) {
      top =  hostBoundingBox.top - imageZoomBoundingBox.height / 2 - 30;
    }
    else {
      top =  hostBoundingBox.top - imageZoomBoundingBox.height / 2 + 30;
    }
    left = hostBoundingBox.left + hostBoundingBox.width + 15;

    setTimeout((): void => {
      this.imageZoomStyle = {
        top: top + 'px',
        left: left + 'px'
      };
    }, this.delay || 0);
  }

}
